import { Alert } from "@mui/material";
import { UserRoleEnum } from "features/users/types";
import { isRoleHigherOrEqual } from "features/users/utils";
import { useAuth } from "features/auth";

export const AccessCheck = ({
  children,
  minAccessLevel,
  showAlert = true,
}: {
  minAccessLevel: UserRoleEnum;
  children: JSX.Element | JSX.Element[];
  showAlert?: boolean;
}) => {
  const { userRole } = useAuth();

  // eslint-disable-next-line no-nested-ternary
  return isRoleHigherOrEqual(userRole, minAccessLevel) ? (
    children
  ) : showAlert ? (
    <Alert severity="error">Access denied</Alert>
  ) : null;
};
